import { IUser } from 'app/shared/model/user.model';

export interface ITenant {
  id?: number;
  name?: string;
  owner?: IUser | null;
  parent?: ITenant | null;
}

export const defaultValue: Readonly<ITenant> = {};
